module.exports = __webpack_public_path__ + "static/assets/3026695dbf8187b9bebcfcc8ecfbe0a5.png";